import {useEffect, useState} from "react";
import initializeSocket from "../socket";
import {useSelector} from "react-redux";

export default function useSocket() {
  const [socket, setSocket] = useState();
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    const initialize = async () => {
      const socket = await initializeSocket();
      // console.log(socket);
      if (socket) {
        setSocket(socket);
      } else {
        console.log("error");
      }
    };

    if (user) initialize();

    return () => {};
  }, [user]);

  return socket;
}
